import React from 'react';

const PartnerLogo = ({ partnerName }) => {
  const logo = require(`./img/${partnerName}.png`);
  return (
    <img className="partner-logo" src={logo} alt="" />
  )
}

export default PartnerLogo;
